<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- systemInformation -->
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- title -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.title"
                [control]="form?.get('title')"
                label="common.title"
              >
              </form-field>
            </div>

            <!-- minPrice -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('minPrice')"
                [value]="model.minPrice"
                (valueChange)="model.minPrice = $event"
                (input)="onChangeMinMaxPrice()"
                [hasCurrency]="true"
                [label]="'common.minPrice' | translate"
                [max]="+model.maxPrice"
              >
              </form-field>
            </div>

            <!-- maxPrice -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('maxPrice')"
                [value]="model.maxPrice"
                (valueChange)="model.maxPrice = $event"
                (input)="onChangeMinMaxPrice()"
                [hasCurrency]="true"
                [label]="'common.maxPrice' | translate"
                [min]="+model.minPrice"
              >
              </form-field>
            </div>

            <!-- mtnSmartPercent -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.mtnSmartPercent"
                [control]="form?.get('mtnSmartPercent')"
                [label]="fields + 'mtnSmartPercent' | translate"
                [hasPercent]="true"
                [min]="0"
                [hasNumberSeparator]="true"
              >
                <span suffix-content> <i class="mdi mdi-percent"></i> </span
              ></form-field>
            </div>

            <!-- mciSmartPercent -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.mciSmartPercent"
                [control]="form?.get('mciSmartPercent')"
                [label]="fields + 'mciSmartPercent' | translate"
                [hasPercent]="true"
                [min]="0"
                [hasNumberSeparator]="true"
              >
                <span suffix-content>
                  <i class="mdi mdi-percent"></i>
                </span>
              </form-field>
            </div>

            <!-- rightelSmartPercent -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.rightelSmartPercent"
                [control]="form?.get('rightelSmartPercent')"
                [label]="fields + 'rightelSmartPercent' | translate"
                [hasPercent]="true"
                [min]="0"
                [hasNumberSeparator]="true"
              >
                <span suffix-content> <i class="mdi mdi-percent"></i> </span
              ></form-field>
            </div>

            <!-- description -->
            <div class="md:tw-w-2/3 xl:tw-w-1/2">
              <form-textarea
                class="tw-w-full font-vazir-ui"
                label="common.description"
                [(value)]="model.description"
                [control]="form?.get('description')"
                [rows]="1"
              >
              </form-textarea>
            </div>

            <!-- isPercentageBenefitForInternational -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-flex tw-items-center"
            >
              <mat-slide-toggle
                formControlName="isPercentageBenefitForInternational"
                [(ngModel)]="model.isPercentageBenefitForInternational"
                (change)="changeIsPercentageBenefitForInternational()"
              >
                {{
                  fields + "isPercentageBenefitForInternational" | translate
                }}</mat-slide-toggle
              >
            </div>

            <!-- internationalBenefitValue -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                *ngIf="model.isPercentageBenefitForInternational"
                [(value)]="model.internationalBenefitValue"
                [control]="form?.get('internationalBenefitValue')"
                [label]="
                  fields + 'internationalBenefitValuePercent' | translate
                "
                [hasPercent]="true"
                [min]="0"
                [hasNumberSeparator]="true"
              >
                <span suffix-content> <i class="mdi mdi-percent"></i> </span
              ></form-field>
              <form-field
                *ngIf="!model.isPercentageBenefitForInternational"
                [(value)]="model.internationalBenefitValue"
                [control]="form?.get('internationalBenefitValue')"
                [label]="fields + 'internationalBenefitValue' | translate"
                [minLength]="1"
                [min]="0"
                [hasCurrency]="true"
                type="number"
              >
              </form-field>
            </div>

            <!-- isDefault -->
            <!-- <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
               <mat-slide-toggle formControlName="isDefault" [(ngModel)]="model.isDefault">
                   {{ "common.isDefault" | translate }}</mat-slide-toggle>
             </div> -->
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
